import SuccessToast from '../../../../components/Toast/SuccessToast';
import ConfirmationModal from '../../User/ConfirmationModal';
import ErrorToast from '../../../../components/Toast/ErrorToast';
import { AddUserSearchResult, ControlButtons, GroupHeader, UserSearchResult, SearchBox } from './components';
import InviteUserModal from '../InviteUserModal/InviteUserModal';
import useGroupInfoModalFunctions from './useGroupInfoModalFunctions';
import Loader from './Loader';
import AddGroupUsersStyles from '../AddGroupUsersModal/AddGroupUsersMoal.module.css';
import { useTranslation } from 'react-i18next';

const STATIC_DATA = [
  { name: '', id: '1' },
  { name: '', id: '2' },
  { name: '', id: '3' },
  { name: '', id: '4' },
  { name: '', id: '5' },
];

const GroupInfoModal = ({ showModal, setShowModal, acceptedUsers, setShowSelectedUser, groupId, socket, getAcceptedUsers, groupName, setGroupName }) => {
  const { t } = useTranslation();
  const {
    isChecked,
    setIsChecked,
    leaveConfirmModal,
    setLeaveConfirmModal,
    circularLoader,
    adminControl,
    setSelectedUserId,
    loading,
    showSuccessToast,
    setShowSuccessToast,
    showInviteModal,
    setShowInviteModal,
    showErrorToast,
    setShowErrorToast,
    nameEdit,
    setNameEdit,
    toastMessage,
    addUser,
    searchQuery,
    searchQuery1,
    inputGrouNameValue,
    setInputGrouNameValue,
    searchResults,
    setSearchResults,
    addUserSearchResults,
    handleSubmit,
    handleRemoveUser,
    handleLeaveGroup,
    onClose,
    handleInputChange,
    handleNameChange,
    handleInputChange1,
    handleCheckboxChange,
    addPartcipiants,
    onBack,
    cardListRef1,
    cardListRef2,
    selectedItems,
  } = useGroupInfoModalFunctions({ setShowModal, setShowSelectedUser, groupId, socket, getAcceptedUsers, groupName, setGroupName });

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 9999,
        backgroundColor: 'rgba(0,0,0,0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div className={AddGroupUsersStyles.modal}>
        <GroupHeader
          onClose={onClose}
          adminControl={adminControl}
          groupName={groupName}
          nameEdit={nameEdit}
          setNameEdit={setNameEdit}
          inputGrouNameValue={inputGrouNameValue}
          setInputGrouNameValue={setInputGrouNameValue}
          handleNameChange={handleNameChange}
        />

        {addUser ? <SearchBox value={searchQuery1} onChange={handleInputChange1} /> : <SearchBox value={searchQuery} onChange={handleInputChange} />}

        <ControlButtons
          onBack={onBack}
          loading={loading}
          addUser={addUser}
          adminControl={adminControl}
          searchResults={searchResults}
          addPartcipiants={addPartcipiants}
          setLeaveConfirmModal={setLeaveConfirmModal}
        />

        {loading ? (
          <Loader data={STATIC_DATA} />
        ) : addUser ? (
          <AddUserSearchResult
            loading={loading}
            addUser={addUser}
            cardListRef2={cardListRef2}
            circularLoader={circularLoader}
            addUserSearchResults={addUserSearchResults}
            handleCheckboxChange={handleCheckboxChange}
          />
        ) : searchResults ? (
          <UserSearchResult
            loading={loading}
            isChecked={isChecked}
            adminControl={adminControl}
            setIsChecked={setIsChecked}
            cardListRef1={cardListRef1}
            searchResults={searchResults}
            circularLoader={circularLoader}
            setSearchResults={setSearchResults}
            handleRemoveUser={handleRemoveUser}
            setSelectedUserId={setSelectedUserId}
            handleCheckboxChange={handleCheckboxChange}
          />
        ) : (
          !loading && (
            <div className={AddGroupUsersStyles.emptyList}>
              <svg width='28' height='28' viewBox='0 0 24 24' fill='none' stroke='#cbd5e1' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
                <circle cx='9' cy='7' r='4' />
              </svg>
              <span>{t('screens.chat.noUsersFound')}</span>
            </div>
          )
        )}

        {addUser && !loading && (
          <div className={AddGroupUsersStyles.footer}>
            <span className={AddGroupUsersStyles.selectedCount}>
              {selectedItems.length > 0 ? t('screens.chat.membersSelected', { count: selectedItems.length }) : t('screens.chat.selectMembersAbove')}
            </span>
            <button className={AddGroupUsersStyles.createBtn} onClick={handleSubmit} disabled={!selectedItems.length}>
              {loading ? t('screens.chat.sending') : t('screens.chat.sendMultiRequest')}
            </button>
          </div>
        )}

        <SuccessToast message={toastMessage} showToast={showSuccessToast} onClose={() => setShowSuccessToast(false)} duration={3500} />

        <ErrorToast message={toastMessage} showToast={showErrorToast} onClose={() => setShowErrorToast(false)} duration={3500} />

        <ConfirmationModal
          title={t('screens.chat.leaveGroup')}
          showModal={leaveConfirmModal}
          handleRemoveUser={handleLeaveGroup}
          message={t('screens.chat.leaveGroupPrompt')}
          buttonLabel={t('screens.chat.leaveGroupBtn')}
          setShowModal={setLeaveConfirmModal}
        />

        <InviteUserModal showModal={showInviteModal} setShowModal={setShowInviteModal} />
      </div>
    </div>
  );
};

export default GroupInfoModal;
